export var transformFormToApiParams = function (data) { return ({
    registrationAgency: data.registrationAgency,
}); };
